import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { getStoreUrl } from '../../../../utils/functionUtils';
import i18n from '../../../common/i18n';
import getHelpFaqGroups from '../../help/commons/helpData';
import safeGetEnv from '../../../../prerender';
import {
  IOS_STORE_LINK, PERSONAL_ADWORDS_LOAN_URL, PLAYSTORE_APP_LINK, PLAYSTORE_APP_LINK_ID, SEND_WPP,
  SITE_URL, WA_CC_NUMBER,
  SOCIAL_INSTAGRAM_URL, SOCIAL_FACEBOOK_URL, SOCIAL_X_URL, SOCIAL_YOUTUBE_URL, SOCIAL_TIKTOK_URL,
} from '../../../../api/env';
import { route } from '../../../navigation/routes';
import prestamoOnline from '../../../../assests/images/home/redesign/prestamoOnline.png';
import lineaCredito from '../../../../assests/images/home/redesign/lineaCredito.png';
import appHomePrestamos from '../../../../assests/images/home/redesign/appHomePrestamos.png';
import appHomeLinea from '../../../../assests/images/home/redesign/appHomeLinea.png';
import appLineaDetalle from '../../../../assests/images/home/redesign/appLineaDetalle.png';
import TikTokIcon from './TikTokIcon';

// Links externos. safeGetEnv evita hornear "${VAR}" sin resolver durante el prerender.
export const getLoanLink = () => safeGetEnv(PERSONAL_ADWORDS_LOAN_URL);

export const getAppStoreLink = () => {
  const base = safeGetEnv(PLAYSTORE_APP_LINK);
  const appId = safeGetEnv(PLAYSTORE_APP_LINK_ID);
  if (base === '#' || appId === '#') return base;
  return `${base}?id=${appId}`;
};

export const getIosStoreLink = () => safeGetEnv(IOS_STORE_LINK);

// Contenido del QR de desktop. Apunta a una landing propia (no a una tienda) porque el QR es
// estático: recién al abrirlo se sabe si el celular que escaneó es Android o iOS.
export const getDownloadAppLink = () => {
  const siteUrl = safeGetEnv(SITE_URL);
  const origin = siteUrl === '#' ? window.location.origin : siteUrl.replace(/\/$/, '');
  return `${origin}${route.downloadApp}`;
};

export const getWhatsappLink = () => {
  const base = safeGetEnv(SEND_WPP);
  const phone = safeGetEnv(WA_CC_NUMBER);
  if (base === '#' || phone === '#') return base;
  return `${base}?phone=${phone}&text=${encodeURIComponent(i18n.homeContactWhatsappMessage)}`;
};

export const HOME_STATS = [
  { id: 'clients', value: i18n.homeAboutStatClientsValue, label: i18n.homeAboutStatClientsLabel },
  { id: 'years', value: i18n.homeAboutStatYearsValue, label: i18n.homeAboutStatYearsLabel },
  { id: 'satisfaction', value: i18n.homeAboutStatSatisfactionValue, label: i18n.homeAboutStatSatisfactionLabel },
];

// Las FAQs de la home son un recorte de las de Ayuda: dos grupos y sus primeras preguntas.
export const HOME_FAQ_GROUP_IDS = ['about', 'wt'];
export const HOME_FAQ_MAX_ITEMS = 5;

export const getHomeFaqGroups = () => {
  const groups = getHelpFaqGroups();
  return HOME_FAQ_GROUP_IDS
    .map((id) => groups.find((group) => group.id === id))
    .filter(Boolean)
    .map((group) => ({ ...group, items: group.items.slice(0, HOME_FAQ_MAX_ITEMS) }));
};

export const getHomeProducts = () => [
  {
    id: 'loan',
    title: i18n.homeSolutionsLoanTitle,
    tag: i18n.homeSolutionsLoanTag,
    description: i18n.homeSolutionsLoanDescription,
    ctaText: i18n.homeSolutionsLoanCta,
    image: prestamoOnline,
    href: getLoanLink(),
    variant: 'default',
  },
  {
    id: 'credit-line',
    title: i18n.homeSolutionsCreditLineTitle,
    tag: i18n.homeSolutionsCreditLineTag,
    description: i18n.homeSolutionsCreditLineDescription,
    ctaText: i18n.homeSolutionsCreditLineCta,
    image: lineaCredito,
    href: getStoreUrl(),
    variant: 'pink',
  },
];

export const HOME_REQUISITES = [
  { id: 'dni', text: i18n.homeRequisitesDni, Icon: HowToRegOutlinedIcon },
  { id: 'income', text: i18n.homeRequisitesIncome, Icon: BusinessCenterOutlinedIcon },
  { id: 'credit-check', text: i18n.homeRequisitesCreditCheck, Icon: VerifiedUserOutlinedIcon },
];

// Demo guiada de la app: 0 home préstamos, 1 tap en el tab, 2 línea con saldo,
// 3 tap en "Ver detalle", 4 pantalla de detalle. El dedo se posiciona en % de la pantalla.
export const APP_DEMO_SCREENS = [appHomePrestamos, appHomeLinea, appLineaDetalle];

export const APP_DEMO_STEPS = [
  {
    duration: 1700,
    caption: i18n.homeAppCaptionLoans,
    screen: 0,
    finger: {
      x: 27, y: 32, pressed: false, visible: true,
    },
  },
  {
    duration: 700,
    caption: i18n.homeAppCaptionLoans,
    screen: 0,
    finger: {
      x: 27, y: 32, pressed: true, visible: true,
    },
  },
  {
    duration: 2400,
    caption: i18n.homeAppCaptionCreditLine,
    screen: 1,
    finger: {
      x: 80, y: 39, pressed: false, visible: true,
    },
  },
  {
    duration: 700,
    caption: i18n.homeAppCaptionCreditLine,
    screen: 1,
    finger: {
      x: 80, y: 39, pressed: true, visible: true,
    },
  },
  {
    duration: 2600,
    caption: i18n.homeAppCaptionDetail,
    screen: 2,
    finger: {
      x: 80, y: 39, pressed: false, visible: false,
    },
  },
];

export const getHomeSocials = () => [
  {
    id: 'instagram', label: 'Instagram', href: safeGetEnv(SOCIAL_INSTAGRAM_URL), Icon: InstagramIcon,
  },
  {
    id: 'facebook', label: 'Facebook', href: safeGetEnv(SOCIAL_FACEBOOK_URL), Icon: FacebookIcon,
  },
  {
    id: 'x', label: 'X', href: safeGetEnv(SOCIAL_X_URL), Icon: XIcon,
  },
  {
    id: 'youtube', label: 'YouTube', href: safeGetEnv(SOCIAL_YOUTUBE_URL), Icon: YouTubeIcon,
  },
  {
    id: 'tiktok', label: 'TikTok', href: safeGetEnv(SOCIAL_TIKTOK_URL), Icon: TikTokIcon,
  },
];
